export function dedent(
  literalSections: TemplateStringsArray,
  ...others: Array<string>
) {
  const fullString = literalSections.reduce(
    (acc, section, i) => `${acc}${section || ''}${others[i] || ''}`,
    ''
  )
  const lines = fullString.split('\n')
  const numSpacesToRemove =
    lines.find(line => !!line)?.match(/^\s*/)?.[0].length ?? 0
  // eslint-disable-next-line security/detect-non-literal-regexp
  const removalRegex = new RegExp(`^ {${numSpacesToRemove}}`)
  return lines.map(line => line.replace(removalRegex, '')).join('\n')
}
